import { useApiMutation } from "../../useApiMutation";

export interface AddManualTransactionPayload {
    personIdentifierId: string;
    personId: number | string;
    entityId: string;
    dateTransaction: string;
    amount: string;
    currencyId: string;
    cashDeskNumber: string;
    receiptNumber: string;
    offers: string;
    motif: string;
    media: string;
}

const useAddManualTransaction = () => {
    const { mutate: addManualTransaction, isLoading, error, success, reset } =
        useApiMutation<AddManualTransactionPayload>("/addManualTransaction");

    return { addManualTransaction, isLoading, error, success, reset };
};

export default useAddManualTransaction;
